var qParameter = "utm_source";
var qCampaign = "utm_campaign";
var defaultWebalias = "CorpOrphan";

function getUrlVars() {
    var vars = {};
    var hashes = window.location.search.substring(1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        let hash = hashes[i].split('=');
        vars[hash[0]] = hash[1] ? decodeURIComponent(hash[1]) : null;
    }
    return vars;
}

function updateCartAttributes() {
    var urlParams = getUrlVars();
    var referral = urlParams[qParameter] ? urlParams[qParameter].toLowerCase() : defaultWebalias.toLowerCase();
    var campaign = urlParams[qCampaign] ? urlParams[qCampaign].toLowerCase() : defaultWebalias.toLowerCase();

    var attributes = {};
    
    if (referral !== defaultWebalias.toLowerCase()) {
        console.log('has referral')
        attributes["Referral"] = referral;
        attributes["utm-source"] = referral;
    }

    if (campaign !== defaultWebalias.toLowerCase()) {
        console.log('has campaign')
        attributes["utm-campaign"] = campaign;
    }

    if (Object.keys(attributes).length > 0) {
        fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ attributes }),
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    updateCartAttributes();
});